import apiClient from '@/api';
import { QueryClient } from '@tanstack/react-query';
import { TIME_CONSTANTS_IN_MS } from '@/constants.ts';
import { MEASUREMENT_GROUPS_BASE_API_URL } from '@/routes/measurement-group/constants.ts';
import { Params } from '@/utils/types.ts';
import { QueryFieldReportsArgs } from './types';
import { buildQueryParams } from '@/utils/build-query-params.ts';
import { FieldReport } from '@/routes/measurement-group/field-report/types.ts';

export const PAGE_SIZES = ['10', '20', '50', '100'];
export const DEFAULT_PAGE_SIZE = '100';

export function queryFieldReportsList(params: QueryFieldReportsArgs) {
	const { search, limit, page, deploymentType, swapReason, hasExternalAntennas } = params;

	const queryParams = buildQueryParams(params);

	return {
		queryKey: ['field-reports', search, limit, page, deploymentType, swapReason, hasExternalAntennas],
		queryFn: () => apiClient.get<FieldReport[]>(`${MEASUREMENT_GROUPS_BASE_API_URL}/field-reports?${queryParams}`)
	};
}

export function loader(queryClient: QueryClient) {
	return async ({ request }: { request: Request }) => {
		const url = new URL(request.url);

		const search = url.searchParams.get(Params.search) || '';
		const page = url.searchParams.get(Params.page) || '1';
		const limit = url.searchParams.get(Params.pageSize) || DEFAULT_PAGE_SIZE;
		const deploymentType = url.searchParams.get(Params.deploymentType) || '';
		const swapReason = url.searchParams.get(Params.swapReason) || '';
		const hasExternalAntennas = url.searchParams.get(Params.hasExternalAntennas) || '';

		const queryParams = {
			search,
			page,
			limit,
			deploymentType,
			swapReason,
			hasExternalAntennas
		};

		const fieldReportsList = await queryClient.fetchQuery({
			...queryFieldReportsList(queryParams),
			staleTime: TIME_CONSTANTS_IN_MS.FIVE_MIN
		});

		return {
			fieldReportsList
		};
	};
}
